import { Expose, Type } from "class-transformer";
import { IsNumber, IsString, IsBoolean, IsArray, ValidateNested, IsDateString } from "class-validator";

export class Chart {
  @IsArray()
  @Expose()
  @Type(() => Series)
  @ValidateNested()
  series: Array<Series> = [];
  @IsArray()
  @Expose()
  categories: Array<string> = [];
}

export class Series {
  @IsString()
  @Expose()
  name!: string;
  @IsNumber()
  @Expose()
  seriesType!: number;
  @IsBoolean()
  @Expose()
  isShow!: boolean;
  @IsArray()
  @Expose()
  data!: Array<number>;
}

export class ComparedData {
  @IsString()
  @Expose()
  name!: string;
  @IsString()
  @Expose()
  value!: string;
  @IsString()
  @Expose()
  percentageDifference!: string;
  @IsDateString()
  @Expose()
  date!: string;
}
export class Statistics {
  @IsArray()
  @Expose()
  @Type(() => ComparedData)
  @ValidateNested()
  dashboardData!: Array<ComparedData>;
}
